<template>
  <div class="pricing-box3">
    <div class="bx1">
      <div class="bx-l" v-for="(v,i) in itemData" :key="i">
        <div class="bx-ic">
          <img :src="v.iconUrl">
        </div>
        <div class="bx-w">
          <div>
            <h3 class="title">{{v.title}}</h3>
            <div v-for="(v1,i) in v.list" :key="i">
              <h3 class="title1" v-html="v1.title"></h3>
              <p class="text">{{v1.text}}</p>
            </div>
          </div>
          <a class="btn2" :href="pathStr.contactUs">{{ v.button.name }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'item03',
  props:{
    itemData: {
      type: Array,
      default: []
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      pathStr: {
        contactUs: '/contact-us'
      }
    }
  },
  mounted() {
    let lan = this.$cookie.get('x-language');
    if(lan == 'en-us' || lan == 'en-us/'){
      // this.pathStr.contactUs = `/contact-us?lan=en-us`
    }
  },
  methods:{
    openPupCU(){
      this.$emit("changeShowStatus", true)
    }
  }
}
</script>
<style lang="scss" scope>
@import '@/assets/css/common.scss';
.pricing-box3{
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  padding: 25px 0 25px;
  position: relative;
  @media screen and (min-width: 801px){
    &:hover{
      .item2{
        img{
          transform: scale(1.05);
        }
      }
    }
  }
  @media screen and (max-width: 800px){
    flex-wrap: wrap;
    padding: 6vw 0;
  }
  @media screen and (max-width:$media-max-width){
    flex-direction: column-reverse;
    padding: 3vw 0 0;
  }

  .bx1{
    width: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media screen and (max-width:$media-max-width){
      flex-direction: column;
    }
  }
  .bx-l{
    width: 49%;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: start;
    background: #f4f5fb;
    box-sizing: border-box;
    padding: 60px 50px;
    min-height: 300px;
    @media screen and (max-width:$media-max-width){
      width: 100%;
      padding: 20px 5% 40px;
      min-height:200px;
      background: #ffffff;
      border-bottom: 1px solid #e6e6e6;
      &:nth-last-child(1){
        border-bottom: none;
      }
    }
  }
  .bx-ic{
    width: 60px;
    @media screen and (max-width:500px){
      width: 35px;
    }
    img{
      width: 73.3%;
    }
  }
  .bx-w{
    width: calc(100% - 60px);
    box-sizing: border-box;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .title{
    color: #2b2b2b;
    font-size: 20px;
    font-family: 'GothamMedium';
    font-weight: normal;
    margin-bottom: 5px;
    @media screen and (max-width:$media-max-width){
      font-size: calc(8px + 2.5vw);
    }
  }
  .text{
    color: #515151;
    font-size: 16px;
    line-height: 22px;
    font-family: 'GothamLight';
    margin-bottom: 15px;
    @media screen and (max-width:$media-max-width){
      font-size: calc(8px + 1.3vw);
      line-height: calc(10px + 1.6vw);
    }
  }
  .title1{
    color: #ba0c2f;
    font-size: 16px;
    font-family: 'GothamLight';
    margin-bottom: 3px;
    span.crl{
      display: inline-block;
      padding: 3px;
      border-radius: 50%;
      background-color: #ba0c2f;
      margin-right: 5px;
      vertical-align: middle;
      @media screen and (max-width:$media-max-width){
        padding: 2px;
      }
    }
  }
  .text2{
    color: #1d1d1e;
    font-size: 16px;
    font-family: 'GothamLight';
    @media screen and (max-width:$media-max-width){
      font-size: calc(8px + 1.1vw);
    }
  }
  a.btn2{
    color: #ffffff;
    background: #ba0c2f;
    display: -webkit-inline-flex;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 33px;
    border-radius: 16.5px;
    font-size: 14px;
    text-transform: uppercase;
    font-family: 'GothamLight';
    cursor: pointer;
    @media screen and (max-width:$media-max-width){
      font-size: calc(8px + 0.8vw);
      width: calc(100px + 8vw);
      height: calc(25px + 1vw);
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/views/pricing/modules/item03.vue